import React from 'react';
import { string } from 'prop-types';
import { Svg, Path } from 'react-native-svg';

const Discount = ({ className, color, size }) => (
    <Svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.3334 13.3333C11.7016 13.3333 12.0001 13.0348 12.0001 12.6666C12.0001 12.2984 11.7016 12 11.3334 12C10.9652 12 10.6667 12.2984 10.6667 12.6666C10.6667 13.0348 10.9652 13.3333 11.3334 13.3333ZM11.3334 16C13.1744 16 14.6667 14.5076 14.6667 12.6666C14.6667 10.8257 13.1744 9.33329 11.3334 9.33329C9.49247 9.33329 8.00008 10.8257 8.00008 12.6666C8.00008 14.5076 9.49247 16 11.3334 16Z"
            fill={color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6667 20C21.0349 20 21.3334 19.7015 21.3334 19.3333C21.3334 18.9651 21.0349 18.6666 20.6667 18.6666C20.2986 18.6666 20.0001 18.9651 20.0001 19.3333C20.0001 19.7015 20.2986 20 20.6667 20ZM20.6667 22.6666C22.5077 22.6666 24.0001 21.1742 24.0001 19.3333C24.0001 17.4923 22.5077 16 20.6667 16C18.8258 16 17.3334 17.4923 17.3334 19.3333C17.3334 21.1742 18.8258 22.6666 20.6667 22.6666Z"
            fill={color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8005 9.59924C21.3896 10.0411 21.509 10.8768 21.0672 11.4659L13.0672 22.1326C12.6253 22.7217 11.7896 22.8411 11.2005 22.3992C10.6114 21.9574 10.492 21.1217 10.9338 20.5326L18.9338 9.8659C19.3756 9.2768 20.2114 9.15741 20.8005 9.59924Z"
            fill={color}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.66675 10.6666C2.66675 6.24835 6.24847 2.66663 10.6667 2.66663H21.3334C25.7517 2.66663 29.3334 6.24835 29.3334 10.6666V21.3333C29.3334 25.7516 25.7517 29.3333 21.3334 29.3333H10.6667C6.24847 29.3333 2.66675 25.7516 2.66675 21.3333V10.6666ZM10.6667 5.33329C7.72123 5.33329 5.33341 7.72111 5.33341 10.6666V21.3333C5.33341 24.2788 7.72123 26.6666 10.6667 26.6666H21.3334C24.2789 26.6666 26.6667 24.2788 26.6667 21.3333V10.6666C26.6667 7.72111 24.2789 5.33329 21.3334 5.33329H10.6667Z"
            fill={color}
        />
    </Svg>
);

Discount.propTypes = {
    className: string,
    color: string,
    size: string,
};

Discount.defaultProps = {
    className: '',
    color: '#068EF9',
    size: '32',
};

export default Discount;
